function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:#F49503;}\n\t.st2{fill:#982B1F;}\n\t.st3{fill:#FFFFFF;}\n\t.st4{fill:url(#SVGID_2_);}\n\t.st5{fill:#F0F0F8;}\n\t.st6{fill:url(#SVGID_3_);}\n\t.st7{fill:url(#SVGID_4_);}\n\t.st8{fill:url(#SVGID_5_);}\n\t.st9{fill:url(#SVGID_6_);}\n\t.st10{fill:url(#SVGID_7_);}\n\t.st11{fill:url(#SVGID_8_);}\n\t.st12{fill:url(#SVGID_9_);}\n\t.st13{fill:url(#SVGID_10_);}\n\t.st14{fill:#F49609;}\n\t.st15{fill:#982C1F;}\n\t.st16{fill:url(#SVGID_11_);}\n\t.st17{fill:#F49606;}\n\t.st18{fill:url(#SVGID_12_);}\n");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M21.4,383.1v0.3c0,18.8,15.2,34.1,34.1,34.1h501.7c18.8,0,34.1-15.2,34.1-34.1v-0.3H21.4L21.4,383.1z"
});

var _ref4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M562.2,326.2c0,0,15.4,11.6,15.4,33.3c0,21.7-13.8,31.8-13.8,31.8H459.2c0,0-13.8-9.3-13.8-31.8 c0-22.5,15.4-33.3,15.4-33.3H562.2 M562.5,325.4h-0.3H460.7h-0.3l-0.2,0.1c-0.2,0.1-15.7,11.4-15.7,34c0,22.6,13.6,32.1,14.2,32.5 l0.2,0.1h0.3h104.6h0.3l0.2-0.2c0.1-0.1,14.2-10.6,14.2-32.5c0-21.9-15.5-33.8-15.7-34L562.5,325.4L562.5,325.4z"
}));

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M460.7,326.2c0,0-15.4,10.9-15.4,33.3c0,22.5,13.8,31.8,13.8,31.8h104.6c0,0,13.8-10.1,13.8-31.8 c0-21.7-15.4-33.3-15.4-33.3H460.7z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M103.2,358h-7.7c-1.1,15.5-10.7,26.1-26.4,26.1c-15.6,0-25.4-10.6-26.5-26.1h-7.7l-6.3,6.5v47.6h80.9v-48 L103.2,358z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M68.9,332.5c13.9,0,25.2,11.3,25.2,25.2c0,13.9-11.3,25.2-25.2,25.2c-13.9,0-25.2-11.3-25.2-25.2 C43.7,343.7,55,332.5,68.9,332.5z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M102.2,359.6h-4.9c-1.1,14.7-13.4,26.3-28.4,26.3c-15,0-27.3-11.6-28.4-26.3h-4.6l-5.7,5.7v45.4h77.6v-45.4 L102.2,359.6z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  className: "st5",
  d: "M87.1,375.6h-36v-36h36V375.6L87.1,375.6z M51.9,374.9h34.5v-34.5H51.9V374.9z"
});

var _ref10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 68.7,
  y: 332.1,
  className: "st5",
  width: 0.8,
  height: 0.8
}), /*#__PURE__*/React.createElement("path", {
  className: "st5",
  d: "M69.4,344.9h-0.8v-1.5h0.8V344.9z M69.4,341.9h-0.8v-1.5h0.8V341.9z M69.4,338.9h-0.8v-1.5h0.8V338.9z  M69.4,335.9h-0.8v-1.5h0.8V335.9z"
}), /*#__PURE__*/React.createElement("rect", {
  x: 68.7,
  y: 346.4,
  className: "st5",
  width: 0.8,
  height: 0.8
}));

var _ref11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 93.1,
  y: 357.2,
  className: "st5",
  width: 0.8,
  height: 0.8
}), /*#__PURE__*/React.createElement("path", {
  className: "st5",
  d: "M91.6,358h-1.5v-0.8h1.5V358z M88.6,358h-1.5v-0.8h1.5V358z M85.6,358h-1.5v-0.8h1.5V358z M82.6,358h-1.5v-0.8 h1.5V358z"
}), /*#__PURE__*/React.createElement("rect", {
  x: 78.8,
  y: 357.2,
  className: "st5",
  width: 0.8,
  height: 0.8
}));

var _ref12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 68.7,
  y: 382.4,
  className: "st5",
  width: 0.8,
  height: 0.8
}), /*#__PURE__*/React.createElement("path", {
  className: "st5",
  d: "M69.4,380.9h-0.8v-1.5h0.8V380.9z M69.4,377.9h-0.8v-1.5h0.8V377.9z M69.4,374.9h-0.8v-1.5h0.8V374.9z  M69.4,371.9h-0.8v-1.5h0.8V371.9z"
}), /*#__PURE__*/React.createElement("rect", {
  x: 68.7,
  y: 368.1,
  className: "st5",
  width: 0.8,
  height: 0.8
}));

var _ref13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 44.3,
  y: 357.2,
  className: "st5",
  width: 0.8,
  height: 0.8
}), /*#__PURE__*/React.createElement("path", {
  className: "st5",
  d: "M57,358h-1.5v-0.8H57V358z M54,358h-1.5v-0.8H54V358z M51,358h-1.5v-0.8H51V358z M48,358h-1.5v-0.8H48V358z"
}), /*#__PURE__*/React.createElement("rect", {
  x: 58.5,
  y: 357.2,
  className: "st5",
  width: 0.8,
  height: 0.8
}));

var _ref14 = /*#__PURE__*/React.createElement("path", {
  className: "st6",
  d: "M69.1,384.5c-14.8,0-26.8-12-26.8-26.8c0-14.8,12-26.8,26.8-26.8c14.8,0,26.8,12,26.8,26.8 C95.9,372.5,83.8,384.5,69.1,384.5z M69.1,333.1c-13.5,0-24.5,11-24.5,24.5c0,13.5,11,24.5,24.5,24.5c13.5,0,24.5-11,24.5-24.5 C93.6,344.1,82.6,333.1,69.1,333.1z"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  className: "st7",
  d: "M103.5,357.6h-7.7c0,0.3,0,0.5,0,0.7l7.4,0l6.1,5.9v47.5H29v-47.5l5.9-5.9l7.4,0c0-0.3-0.1-0.5-0.1-0.8h-7.7 l-6.4,6.3v48.6H110V364L103.5,357.6z"
});

var _ref16 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st5",
  d: "M69.2,381.4c-13.1,0-23.8-10.7-23.8-23.8c0-13.1,10.7-23.8,23.8-23.8c13.1,0,23.8,10.7,23.8,23.8 C92.9,370.8,82.3,381.4,69.2,381.4z M69.2,334.7c-12.7,0-23,10.3-23,23c0,12.7,10.3,23,23,23c12.7,0,23-10.3,23-23 C92.2,345,81.8,334.7,69.2,334.7z"
}));

var _ref17 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M43.5,393.3c1.7,0,2.6,1,2.6,2.8v0.4h-1.7V396c0-0.8-0.3-1.1-0.9-1.1c-0.6,0-0.9,0.3-0.9,1.1 c0,2.3,3.4,2.7,3.4,5.9c0,1.8-0.9,2.8-2.6,2.8s-2.6-1-2.6-2.8v-0.7h1.7v0.8c0,0.8,0.4,1.1,0.9,1.1c0.6,0,0.9-0.3,0.9-1.1 c0-2.3-3.4-2.7-3.4-5.9C40.9,394.4,41.8,393.3,43.5,393.3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M47.1,393.5h1.8v11.2h-1.8V393.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M50.1,393.5h1.8v9.6h2.9v1.6h-4.7V393.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M57.3,404.7h-1.8v-11.2h1.8v4.8h2v-4.8h1.8v11.2h-1.8v-4.8h-2V404.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M62.3,396.1c0-1.8,0.9-2.8,2.7-2.8c1.7,0,2.7,1,2.7,2.8v5.8c0,1.8-0.9,2.8-2.7,2.8c-1.7,0-2.7-1-2.7-2.8V396.1 z M64,402.1c0,0.8,0.4,1.1,0.9,1.1c0.6,0,0.9-0.3,0.9-1.1V396c0-0.8-0.4-1.1-0.9-1.1c-0.6,0-0.9,0.3-0.9,1.1V402.1z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M70.4,393.5v8.6c0,0.8,0.4,1.1,0.9,1.1c0.6,0,0.9-0.3,0.9-1.1v-8.6h1.7v8.5c0,1.8-0.9,2.8-2.6,2.8 c-1.7,0-2.6-1-2.6-2.8v-8.5H70.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M76.9,398.2h2.4v1.6h-2.4v3.3h3v1.6h-4.8v-11.2h4.8v1.6h-3V398.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M80.5,393.5h5.4v1.6h-1.8v9.6h-1.8v-9.6h-1.8V393.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M86.2,393.5h5.4v1.6h-1.8v9.6H88v-9.6h-1.8V393.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M94.1,398.2h2.4v1.6h-2.4v3.3h3v1.6h-4.8v-11.2h4.8v1.6h-3V398.2z"
}));

var _ref18 = /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M195.5,358.2h-7.7c-1.1,15.5-10.7,26.1-26.4,26.1c-15.6,0-25.4-10.6-26.5-26.1h-7.7l-6.3,6.5v47.6h80.9v-48 L195.5,358.2z"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M161.2,332.7c13.9,0,25.2,11.3,25.2,25.2c0,13.9-11.3,25.2-25.2,25.2c-13.9,0-25.2-11.3-25.2-25.2 C136,343.9,147.3,332.7,161.2,332.7z"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M194.5,359.8h-4.9c-1.1,14.7-13.4,26.3-28.4,26.3c-15,0-27.3-11.6-28.4-26.3h-4.6l-5.7,5.7v45.4h77.6v-45.4 L194.5,359.8z"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  className: "st5",
  d: "M179.5,375.8h-36v-36h36V375.8L179.5,375.8z M144.3,375h34.5v-34.5h-34.5V375z"
});

var _ref22 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 161,
  y: 332.3,
  className: "st5",
  width: 0.8,
  height: 0.8
}), /*#__PURE__*/React.createElement("path", {
  className: "st5",
  d: "M161.8,345H161v-1.5h0.8V345z M161.8,342H161v-1.5h0.8V342z M161.8,339H161v-1.5h0.8V339z M161.8,336H161v-1.5 h0.8V336z"
}), /*#__PURE__*/React.createElement("rect", {
  x: 161,
  y: 346.5,
  className: "st5",
  width: 0.8,
  height: 0.8
}));

var _ref23 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 185.4,
  y: 357.4,
  className: "st5",
  width: 0.8,
  height: 0.8
}), /*#__PURE__*/React.createElement("path", {
  className: "st5",
  d: "M183.9,358.2h-1.5v-0.8h1.5V358.2z M180.9,358.2h-1.5v-0.8h1.5V358.2z M177.9,358.2h-1.5v-0.8h1.5V358.2z  M174.9,358.2h-1.5v-0.8h1.5V358.2z"
}), /*#__PURE__*/React.createElement("rect", {
  x: 171.2,
  y: 357.4,
  className: "st5",
  width: 0.8,
  height: 0.8
}));

var _ref24 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 161,
  y: 382.6,
  className: "st5",
  width: 0.8,
  height: 0.8
}), /*#__PURE__*/React.createElement("path", {
  className: "st5",
  d: "M161.8,381.1H161v-1.5h0.8V381.1z M161.8,378.1H161v-1.5h0.8V378.1z M161.8,375.1H161v-1.5h0.8V375.1z  M161.8,372.1H161v-1.5h0.8V372.1z"
}), /*#__PURE__*/React.createElement("rect", {
  x: 161,
  y: 368.3,
  className: "st5",
  width: 0.8,
  height: 0.8
}));

var _ref25 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 136.6,
  y: 357.4,
  className: "st5",
  width: 0.8,
  height: 0.8
}), /*#__PURE__*/React.createElement("path", {
  className: "st5",
  d: "M149.3,358.2h-1.5v-0.8h1.5V358.2z M146.3,358.2h-1.5v-0.8h1.5V358.2z M143.3,358.2h-1.5v-0.8h1.5V358.2z  M140.3,358.2h-1.5v-0.8h1.5V358.2z"
}), /*#__PURE__*/React.createElement("rect", {
  x: 150.8,
  y: 357.4,
  className: "st5",
  width: 0.8,
  height: 0.8
}));

var _ref26 = /*#__PURE__*/React.createElement("path", {
  className: "st9",
  d: "M161.4,384.7c-14.8,0-26.8-12-26.8-26.8c0-14.8,12-26.8,26.8-26.8c14.8,0,26.8,12,26.8,26.8 C188.2,372.6,176.2,384.7,161.4,384.7z M161.4,333.3c-13.5,0-24.5,11-24.5,24.5c0,13.5,11,24.5,24.5,24.5c13.5,0,24.5-11,24.5-24.5 C185.9,344.3,174.9,333.3,161.4,333.3z"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M195.8,357.8h-7.7c0,0.3,0,0.5,0,0.7l7.4,0l6.1,5.9V412h-80.2v-47.5l5.9-5.9l7.4,0c0-0.3-0.1-0.5-0.1-0.8H127 l-6.4,6.3v48.6h81.7v-48.6L195.8,357.8z"
});

var _ref28 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st5",
  d: "M161.5,381.6c-13.1,0-23.8-10.7-23.8-23.8c0-13.1,10.7-23.8,23.8-23.8c13.1,0,23.8,10.7,23.8,23.8 C185.2,371,174.6,381.6,161.5,381.6z M161.5,334.9c-12.7,0-23,10.3-23,23c0,12.7,10.3,23,23,23c12.7,0,23-10.3,23-23 C184.5,345.2,174.2,334.9,161.5,334.9z"
}));

var _ref29 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M149.2,393.5c1.7,0,2.6,1,2.6,2.8v0.4h-1.7v-0.5c0-0.8-0.3-1.1-0.9-1.1c-0.6,0-0.9,0.3-0.9,1.1 c0,2.3,3.4,2.7,3.4,5.9c0,1.8-0.9,2.8-2.6,2.8s-2.6-1-2.6-2.8v-0.7h1.7v0.8c0,0.8,0.4,1.1,0.9,1.1c0.6,0,0.9-0.3,0.9-1.1 c0-2.3-3.4-2.7-3.4-5.9C146.6,394.5,147.5,393.5,149.2,393.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M158,396.4v1.5c0,1.8-0.9,2.8-2.6,2.8h-0.8v4.2h-1.8v-11.2h2.6C157.2,393.6,158,394.6,158,396.4z M154.6,395.2 v3.8h0.8c0.6,0,0.9-0.3,0.9-1.1v-1.7c0-0.8-0.3-1.1-0.9-1.1H154.6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M160.7,398.4h2.4v1.6h-2.4v3.3h3v1.6h-4.8v-11.2h4.8v1.6h-3V398.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M166.6,398.4h2.4v1.6h-2.4v3.3h3v1.6h-4.8v-11.2h4.8v1.6h-3V398.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M170.7,393.6h2.8c1.8,0,2.6,1,2.6,2.8v5.7c0,1.8-0.9,2.8-2.6,2.8h-2.8V393.6z M172.5,395.2v8h1 c0.6,0,0.9-0.3,0.9-1.1v-5.8c0-0.8-0.3-1.1-0.9-1.1H172.5z"
}));

var _ref30 = /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M288.8,358.4H281c-1.1,15.5-10.7,26.1-26.4,26.1c-15.6,0-25.4-10.6-26.5-26.1h-7.7l-6.3,6.5v47.6h80.9v-48 L288.8,358.4z"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M254.4,332.8c13.9,0,25.2,11.3,25.2,25.2c0,13.9-11.3,25.2-25.2,25.2c-13.9,0-25.2-11.3-25.2-25.2 C229.2,344.1,240.5,332.8,254.4,332.8z"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  className: "st11",
  d: "M287.7,359.9h-4.9c-1.1,14.7-13.4,26.3-28.4,26.3c-15,0-27.3-11.6-28.4-26.3h-4.6l-5.7,5.7V411h77.6v-45.4 L287.7,359.9z"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  className: "st5",
  d: "M272.7,376h-36v-36h36V376L272.7,376z M237.5,375.2h34.5v-34.5h-34.5V375.2z"
});

var _ref34 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 254.2,
  y: 332.5,
  className: "st5",
  width: 0.8,
  height: 0.8
}), /*#__PURE__*/React.createElement("path", {
  className: "st5",
  d: "M255,345.2h-0.8v-1.5h0.8V345.2z M255,342.2h-0.8v-1.5h0.8V342.2z M255,339.2h-0.8v-1.5h0.8V339.2z M255,336.2 h-0.8v-1.5h0.8V336.2z"
}), /*#__PURE__*/React.createElement("rect", {
  x: 254.2,
  y: 346.7,
  className: "st5",
  width: 0.8,
  height: 0.8
}));

var _ref35 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 278.6,
  y: 357.6,
  className: "st5",
  width: 0.8,
  height: 0.8
}), /*#__PURE__*/React.createElement("path", {
  className: "st5",
  d: "M277.1,358.4h-1.5v-0.8h1.5V358.4z M274.1,358.4h-1.5v-0.8h1.5V358.4z M271.1,358.4h-1.5v-0.8h1.5V358.4z  M268.1,358.4h-1.5v-0.8h1.5V358.4z"
}), /*#__PURE__*/React.createElement("rect", {
  x: 264.4,
  y: 357.6,
  className: "st5",
  width: 0.8,
  height: 0.8
}));

var _ref36 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 254.2,
  y: 382.8,
  className: "st5",
  width: 0.8,
  height: 0.8
}), /*#__PURE__*/React.createElement("path", {
  className: "st5",
  d: "M255,381.3h-0.8v-1.5h0.8V381.3z M255,378.3h-0.8v-1.5h0.8V378.3z M255,375.3h-0.8v-1.5h0.8V375.3z M255,372.3 h-0.8v-1.5h0.8V372.3z"
}), /*#__PURE__*/React.createElement("rect", {
  x: 254.2,
  y: 368.5,
  className: "st5",
  width: 0.8,
  height: 0.8
}));

var _ref37 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 229.8,
  y: 357.6,
  className: "st5",
  width: 0.8,
  height: 0.8
}), /*#__PURE__*/React.createElement("path", {
  className: "st5",
  d: "M242.6,358.4h-1.5v-0.8h1.5V358.4z M239.6,358.4h-1.5v-0.8h1.5V358.4z M236.6,358.4h-1.5v-0.8h1.5V358.4z  M233.6,358.4h-1.5v-0.8h1.5V358.4z"
}), /*#__PURE__*/React.createElement("rect", {
  x: 244.1,
  y: 357.6,
  className: "st5",
  width: 0.8,
  height: 0.8
}));

var _ref38 = /*#__PURE__*/React.createElement("path", {
  className: "st12",
  d: "M254.6,384.9c-14.8,0-26.8-12-26.8-26.8c0-14.8,12-26.8,26.8-26.8c14.8,0,26.8,12,26.8,26.8 C281.4,372.8,269.4,384.9,254.6,384.9z M254.6,333.5c-13.5,0-24.5,11-24.5,24.5c0,13.5,11,24.5,24.5,24.5c13.5,0,24.5-11,24.5-24.5 C279.1,344.5,268.1,333.5,254.6,333.5z"
});

var _ref39 = /*#__PURE__*/React.createElement("path", {
  className: "st13",
  d: "M289,358h-7.7c0,0.3,0,0.5,0,0.7l7.4,0l6.1,5.9v47.5h-80.2v-47.5l5.9-5.9l7.4,0c0-0.3-0.1-0.5-0.1-0.8h-7.7 l-6.4,6.3v48.6h81.7v-48.6L289,358z"
});

var _ref40 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st5",
  d: "M254.7,381.8c-13.1,0-23.8-10.7-23.8-23.8c0-13.1,10.7-23.8,23.8-23.8c13.1,0,23.8,10.7,23.8,23.8 C278.5,371.1,267.8,381.8,254.7,381.8z M254.7,335c-12.7,0-23,10.3-23,23c0,12.7,10.3,23,23,23c12.7,0,23-10.3,23-23 C277.7,345.4,267.4,335,254.7,335z"
}));

var _ref41 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M232.9,405h-1.8v-11.2h1.8v4.8h2v-4.8h1.8V405h-1.8v-4.8h-2V405z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M243.6,405h-1.8l-0.3-2h-2.2l-0.3,2h-1.6l1.8-11.2h2.6L243.6,405z M239.6,401.5h1.7l-0.8-5.7L239.6,401.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M246,396.9v8.1h-1.6v-11.2h2.2l1.8,6.7v-6.7h1.6V405h-1.8L246,396.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M251.3,393.8h2.8c1.8,0,2.6,1,2.6,2.8v5.7c0,1.8-0.9,2.8-2.6,2.8h-2.8V393.8z M253.1,395.4v8h1 c0.6,0,0.9-0.3,0.9-1.1v-5.8c0-0.8-0.3-1.1-0.9-1.1H253.1z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M257.8,393.8h1.8v9.6h2.9v1.6h-4.7V393.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M263.2,393.8h1.8V405h-1.8V393.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M267.9,396.9v8.1h-1.6v-11.2h2.2l1.8,6.7v-6.7h1.6V405H270L267.9,396.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M275.8,398.8h2.5v3.6c0,1.8-0.9,2.8-2.6,2.8s-2.6-1-2.6-2.8v-5.8c0-1.8,0.9-2.8,2.6-2.8s2.6,1,2.6,2.8v1.1 h-1.7v-1.2c0-0.8-0.4-1.1-0.9-1.1c-0.6,0-0.9,0.3-0.9,1.1v6.1c0,0.8,0.4,1.1,0.9,1.1c0.6,0,0.9-0.3,0.9-1.1v-2.1h-0.8V398.8z"
}));

var _ref42 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st14",
  d: "M552.1,376.2h-81.2L450,357.5v-36.1h122.7v36.1L552.1,376.2z M471.2,375.4h80.6l20.2-18.2v-35.1H450.8v35.1 L471.2,375.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M471.1,375.4h80.7l20.2-18.2l-0.1-35.1H450.7v35.1L471.1,375.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st14",
  d: "M558.2,344.3h-93.6l-12.9-11.5v-9.5h119.5v9.5L558.2,344.3z M464.9,343.6h93l12.4-11.1V324H452.4v8.5 L464.9,343.6z"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st15",
  points: "452.4,323.9 452.4,332.7 465,343.6 558,343.6 570.3,332.7 570.3,323.9  "
}));

var _ref43 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M498.8,339.7h-1.9l-0.3-2.2h-2.3l-0.3,2.2h-1.7l1.9-11.9h2.7L498.8,339.7z M494.5,335.9h1.8l-0.9-6 L494.5,335.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M503.6,339.7c-0.1-0.3-0.2-0.5-0.2-1.5v-1.9c0-1.1-0.4-1.5-1.2-1.5h-0.6v4.9h-1.9v-11.9h2.8 c1.9,0,2.8,0.9,2.8,2.7v0.9c0,1.2-0.4,2-1.2,2.4c0.9,0.4,1.2,1.3,1.2,2.5v1.8c0,0.6,0,1,0.2,1.4H503.6z M501.5,329.4v3.7h0.7 c0.7,0,1.1-0.3,1.1-1.3v-1.2c0-0.9-0.3-1.2-1-1.2H501.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M510.5,336.2l1.3-8.5h2.6v11.9h-1.8v-8.5l-1.3,8.5h-1.8l-1.4-8.4v8.4h-1.6v-11.9h2.6L510.5,336.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M515.5,330.6c0-1.9,1-3,2.8-3c1.8,0,2.8,1.1,2.8,3v6.2c0,1.9-1,3-2.8,3c-1.8,0-2.8-1.1-2.8-3V330.6z  M517.4,336.9c0,0.9,0.4,1.2,1,1.2c0.6,0,1-0.3,1-1.2v-6.4c0-0.9-0.4-1.2-1-1.2c-0.6,0-1,0.3-1,1.2V336.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M526.4,339.7c-0.1-0.3-0.2-0.5-0.2-1.5v-1.9c0-1.1-0.4-1.5-1.2-1.5h-0.6v4.9h-1.9v-11.9h2.8 c1.9,0,2.8,0.9,2.8,2.7v0.9c0,1.2-0.4,2-1.2,2.4c0.9,0.4,1.2,1.3,1.2,2.5v1.8c0,0.6,0,1,0.2,1.4H526.4z M524.3,329.4v3.7h0.7 c0.7,0,1.1-0.3,1.1-1.3v-1.2c0-0.9-0.3-1.2-1-1.2H524.3z"
}));

var _ref44 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M425.3,326.2c0,0,15.4,11.6,15.4,33.3c0,21.7-13.8,31.8-13.8,31.8H322.3c0,0-13.8-9.3-13.8-31.8 c0-22.5,15.4-33.3,15.4-33.3H425.3 M425.6,325.4h-0.3H323.8h-0.3l-0.2,0.1c-0.2,0.1-15.7,11.4-15.7,34c0,22.6,13.6,32.1,14.2,32.5 l0.2,0.1h0.3h104.6h0.3l0.2-0.2c0.1-0.1,14.2-10.6,14.2-32.5c0-21.9-15.5-33.8-15.7-34L425.6,325.4L425.6,325.4z"
}));

var _ref45 = /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M323.8,326.2c0,0-15.4,10.9-15.4,33.3c0,22.5,13.8,31.8,13.8,31.8h104.6c0,0,13.8-10.1,13.8-31.8 c0-21.7-15.4-33.3-15.4-33.3H323.8z"
});

var _ref46 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st14",
  d: "M415.2,376.2H334l-20.9-18.7v-36.1h122.7v36.1L415.2,376.2z M334.3,375.4h80.6l20.2-18.2v-35.1H313.9v35.1 L334.3,375.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M334.2,375.4h80.7l20.2-18.2l-0.1-35.1H313.8v35.1L334.2,375.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st14",
  d: "M421.3,344.3h-93.6l-12.9-11.5v-9.5h119.5v9.5L421.3,344.3z M328,343.6h93l12.4-11.1V324H315.5v8.5L328,343.6 z"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st15",
  points: "315.5,323.9 315.5,332.7 328.1,343.6 421.1,343.6 433.4,332.7 433.4,323.9  "
}));

var _ref47 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M352.6,327.7h3c1.9,0,2.8,1,2.8,2.9v6c0,1.9-0.9,2.9-2.8,2.9h-3V327.7z M354.5,329.4v8.5h1.1 c0.6,0,1-0.3,1-1.2v-6.2c0-0.9-0.4-1.2-1-1.2H354.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M361.4,332.8h2.6v1.7h-2.6v3.5h3.2v1.7h-5.1v-11.9h5.1v1.7h-3.2V332.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M367.7,333h2.4v1.7h-2.4v4.9h-1.9v-11.9h5v1.7h-3.1V333z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M373.6,332.8h2.6v1.7h-2.6v3.5h3.2v1.7h-5.1v-11.9h5.1v1.7h-3.2V332.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M379.6,331v8.6h-1.7v-11.9h2.3l1.9,7.1v-7.1h1.7v11.9H382L379.6,331z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M387.8,327.6c1.8,0,2.8,1.1,2.8,3v0.4h-1.8v-0.5c0-0.9-0.3-1.2-0.9-1.2c-0.6,0-0.9,0.3-0.9,1.2 c0,2.5,3.7,2.9,3.7,6.3c0,1.9-1,3-2.8,3s-2.8-1.1-2.8-3v-0.7h1.8v0.9c0,0.9,0.4,1.2,1,1.2c0.6,0,1-0.3,1-1.2c0-2.5-3.7-2.9-3.7-6.3 C385,328.7,385.9,327.6,387.8,327.6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M393.5,332.8h2.6v1.7h-2.6v3.5h3.2v1.7h-5.1v-11.9h5.1v1.7h-3.2V332.8z"
}));

var _ref48 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M562.3,402.5c0,0,15.4,11.6,15.4,33.3c0,21.7-13.8,31.8-13.8,31.8H459.2c0,0-13.8-9.3-13.8-31.8 c0-22.5,15.4-33.3,15.4-33.3H562.3 M562.6,401.7h-0.3H460.8h-0.3l-0.2,0.1c-0.2,0.1-15.7,11.4-15.7,34c0,22.6,13.6,32.1,14.2,32.5 l0.2,0.1h0.3h104.6h0.3l0.2-0.2c0.1-0.1,14.2-10.6,14.2-32.5c0-21.9-15.5-33.8-15.7-34L562.6,401.7L562.6,401.7z"
}));

var _ref49 = /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M460.8,402.5c0,0-15.4,10.9-15.4,33.3c0,22.5,13.8,31.8,13.8,31.8h104.6c0,0,13.8-10.1,13.8-31.8 c0-21.7-15.4-33.3-15.4-33.3H460.8z"
});

var _ref50 = /*#__PURE__*/React.createElement("path", {
  className: "st16",
  d: "M562.3,402.5h-50.8v65.2h52.3c0,0,13.8-10.1,13.8-31.8C577.7,414.1,562.3,402.5,562.3,402.5z"
});

var _ref51 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st14",
  d: "M552.2,452.5h-81.2l-20.9-18.7v-36.1h122.7v36.1L552.2,452.5z M471.3,451.7h80.6l20.2-18.2v-35.1H450.9v35.1 L471.3,451.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M471.2,451.7h80.7l20.2-18.2l-0.1-35.1H450.8v35.1L471.2,451.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st14",
  d: "M558.3,420.6h-93.6l-12.9-11.5v-9.5h119.5v9.5L558.3,420.6z M464.9,419.9h93l12.4-11.1v-8.5H452.5v8.5 L464.9,419.9z"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st15",
  points: "452.5,400.2 452.5,409 465.1,419.9 558.1,419.9 570.4,409 570.4,400.2  "
}));

var _ref52 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M474.7,404.3c1.8,0,2.8,1.1,2.8,3v0.4h-1.8v-0.5c0-0.9-0.3-1.2-0.9-1.2c-0.6,0-0.9,0.3-0.9,1.2 c0,2.5,3.7,2.9,3.7,6.3c0,1.9-1,3-2.8,3s-2.8-1.1-2.8-3v-0.7h1.8v0.9c0,0.9,0.4,1.2,1,1.2c0.6,0,1-0.3,1-1.2c0-2.5-3.7-2.9-3.7-6.3 C471.9,405.4,472.8,404.3,474.7,404.3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M480.1,412.4l-2.4-8h2l1.4,5.4l1.4-5.4h1.8l-2.4,8v4h-1.9V412.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M487.5,404.3c1.8,0,2.8,1.1,2.8,3v0.4h-1.8v-0.5c0-0.9-0.3-1.2-0.9-1.2c-0.6,0-0.9,0.3-0.9,1.2 c0,2.5,3.7,2.9,3.7,6.3c0,1.9-1,3-2.8,3s-2.8-1.1-2.8-3v-0.7h1.8v0.9c0,0.9,0.4,1.2,1,1.2c0.6,0,1-0.3,1-1.2c0-2.5-3.7-2.9-3.7-6.3 C484.8,405.4,485.7,404.3,487.5,404.3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M490.8,404.4h5.8v1.7h-2v10.2h-1.9v-10.2h-2V404.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M499.3,409.4h2.6v1.7h-2.6v3.5h3.2v1.7h-5.1v-11.9h5.1v1.7h-3.2V409.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M507.7,412.9l1.3-8.5h2.6v11.9h-1.8v-8.5l-1.3,8.5h-1.8l-1.4-8.4v8.4h-1.6v-11.9h2.6L507.7,412.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M518.1,404.3c1.8,0,2.8,1.1,2.8,3v0.4h-1.8v-0.5c0-0.9-0.3-1.2-0.9-1.2c-0.6,0-0.9,0.3-0.9,1.2 c0,2.5,3.7,2.9,3.7,6.3c0,1.9-1,3-2.8,3s-2.8-1.1-2.8-3v-0.7h1.8v0.9c0,0.9,0.4,1.2,1,1.2c0.6,0,1-0.3,1-1.2c0-2.5-3.7-2.9-3.7-6.3 C515.3,405.4,516.3,404.3,518.1,404.3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M521.4,404.4h5.8v1.7h-2v10.2h-1.9v-10.2h-2V404.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M531.9,416.3c-0.1-0.3-0.2-0.5-0.2-1.5V413c0-1.1-0.4-1.5-1.2-1.5h-0.6v4.9H528v-11.9h2.8 c1.9,0,2.8,0.9,2.8,2.7v0.9c0,1.2-0.4,2-1.2,2.4c0.9,0.4,1.2,1.3,1.2,2.5v1.8c0,0.6,0,1,0.2,1.4H531.9z M529.9,406.1v3.7h0.7 c0.7,0,1.1-0.3,1.1-1.3v-1.2c0-0.9-0.3-1.2-1-1.2H529.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M540.9,416.3H539l-0.3-2.2h-2.3l-0.3,2.2h-1.7l1.9-11.9h2.7L540.9,416.3z M536.6,412.6h1.8l-0.9-6L536.6,412.6 z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M541.8,404.4h1.9v11.9h-1.9V404.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M546.7,407.7v8.6H545v-11.9h2.3l1.9,7.1v-7.1h1.7v11.9H549L546.7,407.7z"
}));

var _ref53 = /*#__PURE__*/React.createElement("rect", {
  x: 510.9,
  y: 420.7,
  className: "st17",
  width: 1.2,
  height: 31.1
});

var _ref54 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M425.4,402.5c0,0,15.4,11.6,15.4,33.3c0,21.7-13.8,31.8-13.8,31.8H322.3c0,0-13.8-9.3-13.8-31.8 c0-22.5,15.4-33.3,15.4-33.3H425.4 M425.7,401.7h-0.3H323.9h-0.3l-0.2,0.1c-0.2,0.1-15.7,11.4-15.7,34c0,22.6,13.6,32.1,14.2,32.5 l0.2,0.1h0.3h104.6h0.3l0.2-0.2c0.1-0.1,14.2-10.6,14.2-32.5c0-21.9-15.5-33.8-15.7-34L425.7,401.7L425.7,401.7z"
}));

var _ref55 = /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M323.9,402.5c0,0-15.4,10.9-15.4,33.3c0,22.5,13.8,31.8,13.8,31.8h104.6c0,0,13.8-10.1,13.8-31.8 c0-21.7-15.4-33.3-15.4-33.3H323.9z"
});

var _ref56 = /*#__PURE__*/React.createElement("path", {
  className: "st18",
  d: "M425.4,402.5h-50.8v65.2h52.3c0,0,13.8-10.1,13.8-31.8C440.8,414.1,425.4,402.5,425.4,402.5z"
});

var _ref57 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st14",
  d: "M415.3,452.5H334l-20.9-18.7v-36.1h122.7v36.1L415.3,452.5z M334.4,451.7H415l20.2-18.2v-35.1H314v35.1 L334.4,451.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M334.3,451.7H415l20.2-18.2l-0.1-35.1H313.9v35.1L334.3,451.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st14",
  d: "M421.4,420.6h-93.6l-12.9-11.5v-9.5h119.5v9.5L421.4,420.6z M328.1,419.9h93l12.4-11.1v-8.5H315.6v8.5 L328.1,419.9z"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st15",
  points: "315.6,400.2 315.6,409 328.2,419.9 421.2,419.9 433.5,409 433.5,400.2  "
}));

var _ref58 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M341.7,416.3h-1.9v-11.9h1.9v5.1h2.1v-5.1h1.9v11.9h-1.9v-5.1h-2.1V416.3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M348.9,404.4v9.2c0,0.9,0.4,1.2,1,1.2c0.6,0,1-0.3,1-1.2v-9.2h1.8v9.1c0,1.9-1,3-2.8,3s-2.8-1.1-2.8-3v-9.1 H348.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M353.9,404.4h1.9v10.2h3.1v1.7h-5V404.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M359.6,404.4h1.9v10.2h3.1v1.7h-5V404.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M367.5,404.4h5.8v1.7h-2v10.2h-1.9v-10.2h-2V404.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M378,416.3c-0.1-0.3-0.2-0.5-0.2-1.5V413c0-1.1-0.4-1.5-1.2-1.5H376v4.9h-1.9v-11.9h2.8c1.9,0,2.8,0.9,2.8,2.7 v0.9c0,1.2-0.4,2-1.2,2.4c0.9,0.4,1.2,1.3,1.2,2.5v1.8c0,0.6,0,1,0.2,1.4H378z M376,406.1v3.7h0.7c0.7,0,1.1-0.3,1.1-1.3v-1.2 c0-0.9-0.3-1.2-1-1.2H376z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M387,416.3h-1.9l-0.3-2.2h-2.3l-0.3,2.2h-1.7l1.9-11.9h2.7L387,416.3z M382.7,412.6h1.8l-0.9-6L382.7,412.6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M389.7,404.4v9.2c0,0.9,0.4,1.2,1,1.2c0.6,0,1-0.3,1-1.2v-9.2h1.8v9.1c0,1.9-1,3-2.8,3s-2.8-1.1-2.8-3v-9.1 H389.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M398.6,412.9l1.3-8.5h2.6v11.9h-1.8v-8.5l-1.3,8.5h-1.8l-1.4-8.4v8.4h-1.6v-11.9h2.6L398.6,412.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M409.9,416.3h-1.9l-0.3-2.2h-2.3l-0.3,2.2h-1.7l1.9-11.9h2.7L409.9,416.3z M405.7,412.6h1.8l-0.9-6 L405.7,412.6z"
}));

var _ref59 = /*#__PURE__*/React.createElement("rect", {
  x: 374,
  y: 420.7,
  className: "st17",
  width: 1.2,
  height: 31.1
});

var _ref60 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M329.4,455.8h3.7v1.1h-1.3v6.5h-1.2v-6.5h-1.3V455.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M334.8,463.4h-1.2v-7.6h1.2v3.3h1.4v-3.3h1.2v7.6h-1.2v-3.3h-1.4V463.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M340.8,463.4c-0.1-0.2-0.1-0.3-0.1-0.9v-1.2c0-0.7-0.2-1-0.8-1h-0.4v3.1h-1.2v-7.6h1.8c1.2,0,1.8,0.6,1.8,1.8 v0.6c0,0.8-0.3,1.3-0.8,1.5c0.6,0.3,0.8,0.8,0.8,1.6v1.2c0,0.4,0,0.6,0.1,0.9H340.8z M339.5,456.9v2.3h0.5c0.4,0,0.7-0.2,0.7-0.8 v-0.8c0-0.5-0.2-0.8-0.6-0.8H339.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M343.8,459h1.6v1.1h-1.6v2.2h2.1v1.1h-3.3v-7.6h3.3v1.1h-2.1V459z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M348.2,455.7c1.2,0,1.8,0.7,1.8,1.9v0.2h-1.1v-0.3c0-0.5-0.2-0.8-0.6-0.8s-0.6,0.2-0.6,0.8 c0,1.6,2.3,1.9,2.3,4c0,1.2-0.6,1.9-1.8,1.9s-1.8-0.7-1.8-1.9v-0.5h1.1v0.5c0,0.5,0.2,0.7,0.6,0.7s0.6-0.2,0.6-0.7 c0-1.6-2.3-1.9-2.3-4C346.5,456.4,347.1,455.7,348.2,455.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M351.9,463.4h-1.2v-7.6h1.2v3.3h1.4v-3.3h1.2v7.6h-1.2v-3.3h-1.4V463.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M355.2,457.7c0-1.2,0.6-1.9,1.8-1.9s1.8,0.7,1.8,1.9v4c0,1.2-0.6,1.9-1.8,1.9s-1.8-0.7-1.8-1.9V457.7z  M356.4,461.7c0,0.5,0.2,0.8,0.6,0.8s0.6-0.2,0.6-0.8v-4.1c0-0.5-0.2-0.8-0.6-0.8s-0.6,0.2-0.6,0.8V461.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M359.7,455.8h1.2v6.5h2v1.1h-3.2V455.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M363.3,455.8h1.9c1.2,0,1.8,0.7,1.8,1.9v3.9c0,1.2-0.6,1.9-1.8,1.9h-1.9V455.8z M364.5,456.9v5.4h0.7 c0.4,0,0.6-0.2,0.6-0.7v-4c0-0.5-0.2-0.7-0.6-0.7H364.5z"
}));

var _ref61 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M383.7,460.6v1c0,1.2-0.6,1.9-1.8,1.9c-1.2,0-1.8-0.7-1.8-1.9v-4c0-1.2,0.6-1.9,1.8-1.9c1.2,0,1.8,0.7,1.8,1.9 v0.7h-1.1v-0.8c0-0.5-0.2-0.8-0.6-0.8s-0.6,0.2-0.6,0.8v4.1c0,0.5,0.2,0.7,0.6,0.7s0.6-0.2,0.6-0.7v-1.1H383.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M385.6,455.8v5.9c0,0.5,0.2,0.7,0.6,0.7s0.6-0.2,0.6-0.7v-5.9h1.1v5.8c0,1.2-0.6,1.9-1.8,1.9s-1.8-0.7-1.8-1.9 v-5.8H385.6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M391.2,463.4c-0.1-0.2-0.1-0.3-0.1-0.9v-1.2c0-0.7-0.2-1-0.8-1h-0.4v3.1h-1.2v-7.6h1.8c1.2,0,1.8,0.6,1.8,1.8 v0.6c0,0.8-0.3,1.3-0.8,1.5c0.6,0.3,0.8,0.8,0.8,1.6v1.2c0,0.4,0,0.6,0.1,0.9H391.2z M389.9,456.9v2.3h0.5c0.4,0,0.7-0.2,0.7-0.8 v-0.8c0-0.5-0.2-0.8-0.6-0.8H389.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M395.6,463.4c-0.1-0.2-0.1-0.3-0.1-0.9v-1.2c0-0.7-0.2-1-0.8-1h-0.4v3.1h-1.2v-7.6h1.8c1.2,0,1.8,0.6,1.8,1.8 v0.6c0,0.8-0.3,1.3-0.8,1.5c0.6,0.3,0.8,0.8,0.8,1.6v1.2c0,0.4,0,0.6,0.1,0.9H395.6z M394.3,456.9v2.3h0.5c0.4,0,0.7-0.2,0.7-0.8 v-0.8c0-0.5-0.2-0.8-0.6-0.8H394.3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M398.7,459h1.6v1.1h-1.6v2.2h2.1v1.1h-3.3v-7.6h3.3v1.1h-2.1V459z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M402.6,457.9v5.5h-1.1v-7.6h1.5l1.2,4.6v-4.6h1.1v7.6h-1.2L402.6,457.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M405.8,455.8h3.7v1.1h-1.3v6.5H407v-6.5h-1.3V455.8z"
}));

var _ref62 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M467.2,455.8h3.7v1.1h-1.3v6.5h-1.2v-6.5h-1.3V455.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M472.6,463.4h-1.2v-7.6h1.2v3.3h1.4v-3.3h1.2v7.6H474v-3.3h-1.4V463.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M478.6,463.4c-0.1-0.2-0.1-0.3-0.1-0.9v-1.2c0-0.7-0.2-1-0.8-1h-0.4v3.1h-1.2v-7.6h1.8c1.2,0,1.8,0.6,1.8,1.8 v0.6c0,0.8-0.3,1.3-0.8,1.5c0.6,0.3,0.8,0.8,0.8,1.6v1.2c0,0.4,0,0.6,0.1,0.9H478.6z M477.3,456.9v2.3h0.5c0.4,0,0.7-0.2,0.7-0.8 v-0.8c0-0.5-0.2-0.8-0.6-0.8H477.3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M481.6,459h1.6v1.1h-1.6v2.2h2.1v1.1h-3.3v-7.6h3.3v1.1h-2.1V459z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M486,455.7c1.2,0,1.8,0.7,1.8,1.9v0.2h-1.1v-0.3c0-0.5-0.2-0.8-0.6-0.8s-0.6,0.2-0.6,0.8c0,1.6,2.3,1.9,2.3,4 c0,1.2-0.6,1.9-1.8,1.9s-1.8-0.7-1.8-1.9v-0.5h1.1v0.5c0,0.5,0.2,0.7,0.6,0.7s0.6-0.2,0.6-0.7c0-1.6-2.3-1.9-2.3-4 C484.3,456.4,484.9,455.7,486,455.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M489.7,463.4h-1.2v-7.6h1.2v3.3h1.4v-3.3h1.2v7.6h-1.2v-3.3h-1.4V463.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M493,457.7c0-1.2,0.6-1.9,1.8-1.9s1.8,0.7,1.8,1.9v4c0,1.2-0.6,1.9-1.8,1.9s-1.8-0.7-1.8-1.9V457.7z  M494.2,461.7c0,0.5,0.2,0.8,0.6,0.8s0.6-0.2,0.6-0.8v-4.1c0-0.5-0.2-0.8-0.6-0.8s-0.6,0.2-0.6,0.8V461.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M497.5,455.8h1.2v6.5h2v1.1h-3.2V455.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M501.1,455.8h1.9c1.2,0,1.8,0.7,1.8,1.9v3.9c0,1.2-0.6,1.9-1.8,1.9h-1.9V455.8z M502.3,456.9v5.4h0.7 c0.4,0,0.6-0.2,0.6-0.7v-4c0-0.5-0.2-0.7-0.6-0.7H502.3z"
}));

var _ref63 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M521.5,460.6v1c0,1.2-0.6,1.9-1.8,1.9c-1.2,0-1.8-0.7-1.8-1.9v-4c0-1.2,0.6-1.9,1.8-1.9c1.2,0,1.8,0.7,1.8,1.9 v0.7h-1.1v-0.8c0-0.5-0.2-0.8-0.6-0.8s-0.6,0.2-0.6,0.8v4.1c0,0.5,0.2,0.7,0.6,0.7s0.6-0.2,0.6-0.7v-1.1H521.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M523.4,455.8v5.9c0,0.5,0.2,0.7,0.6,0.7s0.6-0.2,0.6-0.7v-5.9h1.1v5.8c0,1.2-0.6,1.9-1.8,1.9s-1.8-0.7-1.8-1.9 v-5.8H523.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M529,463.4c-0.1-0.2-0.1-0.3-0.1-0.9v-1.2c0-0.7-0.2-1-0.8-1h-0.4v3.1h-1.2v-7.6h1.8c1.2,0,1.8,0.6,1.8,1.8 v0.6c0,0.8-0.3,1.3-0.8,1.5c0.6,0.3,0.8,0.8,0.8,1.6v1.2c0,0.4,0,0.6,0.1,0.9H529z M527.7,456.9v2.3h0.5c0.4,0,0.7-0.2,0.7-0.8 v-0.8c0-0.5-0.2-0.8-0.6-0.8H527.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M533.4,463.4c-0.1-0.2-0.1-0.3-0.1-0.9v-1.2c0-0.7-0.2-1-0.8-1h-0.4v3.1h-1.2v-7.6h1.8c1.2,0,1.8,0.6,1.8,1.8 v0.6c0,0.8-0.3,1.3-0.8,1.5c0.6,0.3,0.8,0.8,0.8,1.6v1.2c0,0.4,0,0.6,0.1,0.9H533.4z M532.1,456.9v2.3h0.5c0.4,0,0.7-0.2,0.7-0.8 v-0.8c0-0.5-0.2-0.8-0.6-0.8H532.1z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M536.5,459h1.6v1.1h-1.6v2.2h2.1v1.1h-3.3v-7.6h3.3v1.1h-2.1V459z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M540.4,457.9v5.5h-1.1v-7.6h1.5l1.2,4.6v-4.6h1.1v7.6h-1.2L540.4,457.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M543.6,455.8h3.7v1.1H546v6.5h-1.2v-6.5h-1.3V455.8z"
}));

function SvgVehicleStatBlock(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "20 320 575 150",
    xmlSpace: "preserve",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    x1: 84.8292,
    y1: 494.5827,
    x2: 499.3358,
    y2: 316.692,
    gradientTransform: "matrix(1 0 0 -1 0 794)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F8AE48"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D37E11"
    }
  })), _ref3, _ref4, _ref5, _ref6, _ref7, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    x1: 48.1379,
    y1: 1405.6265,
    x2: 85.1987,
    y2: 1358.5918,
    gradientTransform: "matrix(1 0 0 -1 0 1767)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#12598C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2953,
    style: {
      stopColor: "#1A5486"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6961,
    style: {
      stopColor: "#214978"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9785,
    style: {
      stopColor: "#273D6C"
    }
  })), _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    x1: 61.1029,
    y1: 1417.6346,
    x2: 98.1572,
    y2: 1378.9111,
    gradientTransform: "matrix(1 0 0 -1 0 1767)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#12598C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2953,
    style: {
      stopColor: "#1A5486"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6961,
    style: {
      stopColor: "#214978"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9785,
    style: {
      stopColor: "#273D6C"
    }
  })), _ref14, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    x1: 41.3255,
    y1: 1401.1924,
    x2: 105.6088,
    y2: 1350.6982,
    gradientTransform: "matrix(1 0 0 -1 0 1767)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#12598C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2953,
    style: {
      stopColor: "#1A5486"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6961,
    style: {
      stopColor: "#214978"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9785,
    style: {
      stopColor: "#273D6C"
    }
  })), _ref15, _ref16, _ref17, _ref18, _ref19, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    x1: 140.4612,
    y1: 1405.4412,
    x2: 177.522,
    y2: 1358.4065,
    gradientTransform: "matrix(1 0 0 -1 0 1767)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#12598C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2953,
    style: {
      stopColor: "#1A5486"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6961,
    style: {
      stopColor: "#214978"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9785,
    style: {
      stopColor: "#273D6C"
    }
  })), _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    x1: 153.4262,
    y1: 1417.4493,
    x2: 190.4804,
    y2: 1378.7258,
    gradientTransform: "matrix(1 0 0 -1 0 1767)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#12598C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2953,
    style: {
      stopColor: "#1A5486"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6961,
    style: {
      stopColor: "#214978"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9785,
    style: {
      stopColor: "#273D6C"
    }
  })), _ref26, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    x1: 133.6488,
    y1: 1401.0071,
    x2: 197.9321,
    y2: 1350.5129,
    gradientTransform: "matrix(1 0 0 -1 0 1767)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#12598C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2953,
    style: {
      stopColor: "#1A5486"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6961,
    style: {
      stopColor: "#214978"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9785,
    style: {
      stopColor: "#273D6C"
    }
  })), _ref27, _ref28, _ref29, _ref30, _ref31, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    x1: 233.6773,
    y1: 1405.2559,
    x2: 270.738,
    y2: 1358.2212,
    gradientTransform: "matrix(1 0 0 -1 0 1767)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#12598C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2953,
    style: {
      stopColor: "#1A5486"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6961,
    style: {
      stopColor: "#214978"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9785,
    style: {
      stopColor: "#273D6C"
    }
  })), _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    x1: 246.6423,
    y1: 1417.264,
    x2: 283.6965,
    y2: 1378.5405,
    gradientTransform: "matrix(1 0 0 -1 0 1767)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#12598C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2953,
    style: {
      stopColor: "#1A5486"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6961,
    style: {
      stopColor: "#214978"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9785,
    style: {
      stopColor: "#273D6C"
    }
  })), _ref38, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    x1: 226.8649,
    y1: 1400.8218,
    x2: 291.1482,
    y2: 1350.3276,
    gradientTransform: "matrix(1 0 0 -1 0 1767)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#12598C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2953,
    style: {
      stopColor: "#1A5486"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6961,
    style: {
      stopColor: "#214978"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9785,
    style: {
      stopColor: "#273D6C"
    }
  })), _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    x1: 531.2159,
    y1: 429.7694,
    x2: 565.6807,
    y2: 461.3676
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0E588B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2959,
    style: {
      stopColor: "#155486"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6975,
    style: {
      stopColor: "#204878"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9785,
    style: {
      stopColor: "#253E6C"
    }
  })), _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    x1: 394.3256,
    y1: 429.7694,
    x2: 428.7903,
    y2: 461.3676
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0E588B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2959,
    style: {
      stopColor: "#155486"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6975,
    style: {
      stopColor: "#204878"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9785,
    style: {
      stopColor: "#253E6C"
    }
  })), _ref56, _ref57, _ref58, _ref59, _ref60, _ref61, _ref62, _ref63);
}

export default __webpack_public_path__ + "VehicleStatBlock.4af1ba4.svg";
export { SvgVehicleStatBlock as ReactComponent };